(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["simluxx-about-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('simluxx-about-video')) {
    customElements.define('simluxx-about-video', class extends HTMLElement {
      connectedCallback() {
        if (this.video) return;
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.button = this.querySelector('.slx-about-story__toggle');
        this.controlsRow = this.querySelector('.slx-about-story__controls');
        this.playText = this.querySelector('.slx-about-story__play-text');
        this.pauseText = this.querySelector('.slx-about-story__pause-text');
        this.picture = this.querySelector('picture');
        this.errorLink = this.querySelector('.slx-about-story__error-link');
        this.track = this.querySelector('track');
        this.mediaQuery = window.matchMedia('(max-width: 749px)');
        this.intent = this.intent || 'auto';
        this.video.controls = false;
        this.video.defaultMuted = true;
        this.video.muted = true;
        this.video.playsInline = true;
        this.video.loop = true;
        this.video.removeAttribute('controls');
        this.onChange = () => this.selectSource();
        this.onPageShow = () => this.syncPlayback();
        this.onVisibility = () => this.syncPlayback();
        this.onToggle = () => {
          this.intent = this.video.paused ? 'play' : 'pause';
          this.syncPlayback();
        };
        this.onPlaying = () => {
          if (this.picture) this.picture.hidden = true;
          if (this.errorLink) this.errorLink.hidden = true;
          this.updateButton();
        };
        this.onPause = () => this.updateButton();
        this.onReady = () => this.syncPlayback();
        this.onError = () => {
          if (this.picture) this.picture.hidden = false;
          if (this.errorLink) this.errorLink.hidden = false;
          this.updateButton();
        };
        this.mediaQuery.addEventListener('change', this.onChange);
        window.addEventListener('pageshow', this.onPageShow);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.button?.addEventListener('click', this.onToggle);
        this.video.addEventListener('playing', this.onPlaying);
        this.video.addEventListener('pause', this.onPause);
        this.video.addEventListener('canplay', this.onReady);
        this.video.addEventListener('error', this.onError);
        if (this.controlsRow) this.controlsRow.hidden = false;
        this.selectSource();
      }
      selectSource() {
        this.revision = (this.revision || 0) + 1;
        this.pendingPlay = null;
        const mobile = this.mediaQuery.matches;
        const source = mobile ? this.dataset.mobileSrc : this.dataset.desktopSrc;
        const poster = mobile ? this.dataset.mobilePoster : this.dataset.desktopPoster;
        const captions = mobile ? this.dataset.mobileCaptions : this.dataset.desktopCaptions;
        this.video.pause();
        this.video.autoplay = false;
        this.video.controls = false;
        this.video.defaultMuted = true;
        this.video.muted = true;
        this.video.poster = poster;
        this.video.src = source;
        if (this.picture) this.picture.hidden = false;
        if (this.errorLink) {
          this.errorLink.href = source;
          this.errorLink.hidden = true;
        }
        if (this.track) {
          if (captions) this.track.src = captions;
          else this.track.removeAttribute('src');
        }
        this.video.load();
        this.updateButton();
        this.syncPlayback();
      }
      syncPlayback() {
        if (!this.video || !this.isConnected) return;
        const wantsPlay = this.intent === 'play' || this.intent === 'auto';
        const shouldPlay = wantsPlay && !document.hidden;
        this.video.autoplay = shouldPlay;
        if (!shouldPlay) {
          this.video.pause();
          this.updateButton();
          return;
        }
        if (!this.video.paused || this.pendingPlay) return;
        const revision = this.revision;
        const playback = this.video.play();
        if (playback && typeof playback.catch === 'function') {
          this.pendingPlay = playback;
          playback.catch(() => {
            if (this.isConnected && this.video && revision === this.revision) this.updateButton();
          }).finally(() => {
            if (this.pendingPlay === playback) this.pendingPlay = null;
          });
        }
      }
      updateButton() {
        if (!this.button || !this.video) return;
        const paused = this.video.paused;
        this.button.setAttribute('aria-label', paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        if (this.playText) this.playText.hidden = !paused;
        if (this.pauseText) this.pauseText.hidden = paused;
      }
      disconnectedCallback() {
        if (!this.video) return;
        this.revision = (this.revision || 0) + 1;
        this.mediaQuery.removeEventListener('change', this.onChange);
        window.removeEventListener('pageshow', this.onPageShow);
        document.removeEventListener('visibilitychange', this.onVisibility);
        this.button?.removeEventListener('click', this.onToggle);
        this.video.removeEventListener('playing', this.onPlaying);
        this.video.removeEventListener('pause', this.onPause);
        this.video.removeEventListener('canplay', this.onReady);
        this.video.removeEventListener('error', this.onError);
        this.video.autoplay = false;
        this.video.pause();
        this.video.removeAttribute('src');
        this.video.load();
        this.pendingPlay = null;
        this.video = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simluxx-brand-visuals"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('simluxx-visuals')) {
    customElements.define('simluxx-visuals', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        const comparison = this.querySelector('.slx-visuals__compare');
        const range = this.querySelector('.slx-visuals__range');
        const cta = this.querySelector('[data-auto-contact]');
        if (comparison && range) {
          this.classList.add('is-enhanced');
          const updateReveal = () => {
            const value = Math.max(0, Math.min(100, Number(range.value) || 0));
            comparison.style.setProperty('--sv-reveal', value + '%');
            range.setAttribute('aria-valuetext', value + '% ' + range.dataset.before + ', ' + (100 - value) + '% ' + range.dataset.after);
          };
          range.hidden = false;
          updateReveal();
          range.addEventListener('input', updateReveal, options);
          range.addEventListener('keydown', event => {
            if (event.altKey || event.ctrlKey || event.metaKey) return;
            let value = Number(range.value);
            if (event.key === 'ArrowRight' || event.key === 'ArrowUp') value += 1;
            else if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') value -= 1;
            else if (event.key === 'PageUp') value += 10;
            else if (event.key === 'PageDown') value -= 10;
            else if (event.key === 'Home') value = 0;
            else if (event.key === 'End') value = 100;
            else return;
            event.preventDefault();
            range.value = String(Math.max(0, Math.min(100, value)));
            updateReveal();
          }, options);
          let pointer = null;
          const moveReveal = event => {
            const rect = comparison.getBoundingClientRect();
            if (rect.width > 0) {
              range.value = String(Math.round(Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width)) * 100));
              updateReveal();
            }
          };
          comparison.addEventListener('pointerdown', event => {
            if (event.button !== 0 || !event.isPrimary) return;
            pointer = event.pointerId;
            comparison.setPointerCapture(pointer);
            if (event.pointerType === 'mouse') { event.preventDefault(); range.focus({ preventScroll: true }); }
            moveReveal(event);
          }, options);
          comparison.addEventListener('pointermove', event => { if (event.pointerId === pointer) moveReveal(event); }, options);
          const finish = event => {
            if (event.pointerId !== pointer) return;
            if (comparison.hasPointerCapture(pointer)) comparison.releasePointerCapture(pointer);
            pointer = null;
          };
          comparison.addEventListener('pointerup', finish, options);
          comparison.addEventListener('pointercancel', finish, options);
        }
        const resolveContact = () => {
          const field = document.querySelector('main form [name="contact[body]"]');
          const form = field?.closest('form');
          const target = form?.closest('.shopify-section[id]') || form;
          if (cta && target?.id) cta.setAttribute('href', '#' + encodeURIComponent(target.id));
        };
        if (cta) {
          resolveContact();
          cta.addEventListener('click', resolveContact, options);
        }
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simluxx-event-slideshow"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('slx-event-slideshow')) {
  customElements.define('slx-event-slideshow', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => { if (this.isConnected) this.init(); });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.animation?.cancel();
      this.touch = null;
    }
    init() {
      if (this.controller) return;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      if (!this.slides.length) return;
      this.choices = [...this.querySelectorAll('[data-go]')];
      this.status = this.querySelector('[data-status]');
      this.current = Math.max(0, this.slides.findIndex(slide => !slide.hidden));
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const direction = () => getComputedStyle(this).direction === 'rtl' ? -1 : 1;
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-go')) this.show(Number(button.dataset.go));
        if (button.hasAttribute('data-step')) this.show(this.current + Number(button.dataset.step));
      }, options);
      this.addEventListener('keydown', event => {
        if (!event.target.closest('button') || event.altKey || event.ctrlKey || event.metaKey) return;
        let next;
        if (event.key === 'ArrowRight') next = this.current + direction();
        if (event.key === 'ArrowLeft') next = this.current - direction();
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.slides.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this.show(next);
      }, options);
      this.addEventListener('touchstart', event => {
        if (event.touches.length !== 1 || !event.target.closest('.slx-showcase__media')) { this.touch = null; return; }
        this.touch = [event.touches[0].clientX, event.touches[0].clientY];
      }, { ...options, passive: true });
      this.addEventListener('touchend', event => {
        if (!this.touch || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - this.touch[0];
        const dy = event.changedTouches[0].clientY - this.touch[1];
        this.touch = null;
        if (Math.abs(dx) > 45 && Math.abs(dy) < Math.abs(dx) * .6) this.show(this.current + (dx < 0 ? 1 : -1) * direction());
      }, { ...options, passive: true });
      this.addEventListener('touchcancel', () => { this.touch = null; }, options);
      document.addEventListener('shopify:block:select', event => {
        if (event.detail?.sectionId && event.detail.sectionId !== this.dataset.sectionId) return;
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
        if (index >= 0) this.show(index, false);
      }, options);
      this.setAttribute('ready', '');
      this.show(this.current, false);
    }
    show(index, announce = true) {
      if (!Number.isFinite(index)) return;
      this.current = (index % this.slides.length + this.slides.length) % this.slides.length;
      this.animation?.cancel();
      this.slides.forEach((slide, i) => {
        const inactive = i !== this.current;
        slide.hidden = inactive;
        slide.inert = inactive;
        slide.setAttribute('aria-hidden', String(inactive));
      });
      this.choices.forEach((button, i) => button.setAttribute('aria-pressed', String(i === this.current)));
      const active = this.slides[this.current];
      if (announce && this.status) this.status.textContent = `${this.current + 1} / ${this.slides.length}: ${active.dataset.label}`;
      if (announce && active.animate && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.animation = active.animate([{ opacity: .7 }, { opacity: 1 }], { duration: 180 });
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simluxx-live-leaderboards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('slx-leaderboard-gallery')) {
    customElements.define('slx-leaderboard-gallery', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        queueMicrotask(() => {
          if (!this.isConnected || this.abortController.signal.aborted) return;
          this.initialize();
        });
      }

      initialize() {
        if (this.ready) return;
        this.dialog = this.querySelector('.slx-leaderboards__dialog');
        if (!this.dialog) return;
        this.ready = true;
        this.closeButton = this.querySelector('[data-slx-close]');
        this.dialogTitle = this.querySelector('[data-slx-dialog-title]');
        this.dialogMedia = this.querySelector('[data-slx-dialog-media]');
        this.originalLink = this.querySelector('[data-slx-original]');
        const options = { signal: this.abortController.signal };
        if (typeof this.dialog.showModal !== 'function') return;
        this.querySelectorAll('[data-slx-open]').forEach(link => link.setAttribute('aria-haspopup', 'dialog'));

        this.addEventListener('click', event => {
          const link = event.target.closest('[data-slx-open]');
          if (!link || !this.contains(link) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const preview = link.querySelector('img');
          if (!preview) return;
          event.preventDefault();
          if (this.dialog.open) return;
          this.opener = link;
          this.dialogTitle.textContent = link.dataset.slxCaption;
          this.originalLink.href = link.href;
          const image = preview.cloneNode();
          image.removeAttribute('class');
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.removeAttribute('loading');
          image.src = link.href;
          this.dialogMedia.replaceChildren(image);
          this.dialog.showModal();
          this.closeButton.focus({ preventScroll: true });
        }, options);

        this.closeButton.addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('close', () => {
          if (this.dialog.open) return;
          this.dialogMedia.replaceChildren();
          const opener = this.opener;
          this.opener = null;
          if (this.isConnected && opener?.isConnected) opener.focus({ preventScroll: true });
        }, options);
        this.dialog.addEventListener('pointerdown', event => { this.backdropStart = event.target === this.dialog && this.isOutsideDialog(event); }, options);
        this.dialog.addEventListener('click', event => {
          if (this.backdropStart && event.target === this.dialog && this.isOutsideDialog(event)) this.dialog.close();
          this.backdropStart = false;
        }, options);
        this.dialog.addEventListener('keydown', event => {
          if (event.key !== 'Tab') return;
          const first = this.closeButton;
          const last = this.originalLink;
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }, options);
        this.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => this.cleanup(), options);
      }

      isOutsideDialog(event) {
        const bounds = this.dialog.getBoundingClientRect();
        return event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom;
      }

      cleanup() {
        this.abortController?.abort();
        this.ready = false;
        this.opener = null;
        if (this.dialog?.open) this.dialog.close();
        this.dialogMedia?.replaceChildren();
      }

      disconnectedCallback() { this.cleanup(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simluxx-portrait-video"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('simluxx-rental-video')) {
  customElements.define('simluxx-rental-video', class extends HTMLElement {
    connectedCallback() {
      if (this.video) return;
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.frame = this.querySelector('[data-slx-video-frame]');
      this.button = this.querySelector('[data-slx-toggle]');
      this.soundButton = this.querySelector('[data-slx-sound]');
      this.controlsRow = this.querySelector('[data-slx-controls]');
      this.errorLink = this.querySelector('[data-slx-fallback]');
      this.intent = this.intent || 'auto';
      this.video.controls = false;
      this.video.defaultMuted = true;
      this.video.muted = true;
      this.video.playsInline = true;
      this.video.removeAttribute('controls');
      this.onToggle = () => {
        this.intent = this.video.paused ? 'play' : 'pause';
        this.syncPlayback();
      };
      this.onSound = () => {
        this.video.muted = !this.video.muted;
        this.updateButtons();
        if (!this.video.muted) {
          this.intent = 'play';
          this.syncPlayback();
        }
      };
      this.onState = () => this.updateButtons();
      this.onPlaying = () => {
        if (this.errorLink) this.errorLink.hidden = true;
        this.updateButtons();
      };
      this.onEnded = () => {
        this.intent = 'pause';
        this.video.autoplay = false;
        this.updateButtons();
      };
      this.onError = () => {
        if (this.errorLink) this.errorLink.hidden = false;
        this.updateButtons();
      };
      this.onVisibility = () => this.syncPlayback();
      this.onReady = () => this.syncPlayback();
      this.onPageShow = () => this.syncPlayback();
      this.button?.addEventListener('click', this.onToggle);
      this.soundButton?.addEventListener('click', this.onSound);
      this.video.addEventListener('playing', this.onPlaying);
      this.video.addEventListener('pause', this.onState);
      this.video.addEventListener('volumechange', this.onState);
      this.video.addEventListener('ended', this.onEnded);
      this.video.addEventListener('error', this.onError);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.video.addEventListener('canplay', this.onReady);
      window.addEventListener('pageshow', this.onPageShow);
      if (this.controlsRow) this.controlsRow.hidden = false;
      this.updateButtons();
      this.syncPlayback();
    }
    syncPlayback() {
      if (!this.video || !this.isConnected) return;
      const wantsPlay = this.intent === 'play' || (this.intent === 'auto' && this.dataset.autoplay === 'true');
      const shouldPlay = wantsPlay && !document.hidden;
      this.video.autoplay = shouldPlay;
      if (!shouldPlay) {
        this.video.pause();
        this.updateButtons();
        return;
      }
      if (!this.video.paused || this.pendingPlay) return;
      const video = this.video;
      const playback = video.play();
      if (playback && typeof playback.catch === 'function') {
        this.pendingPlay = playback;
        playback.catch(() => {
          if (this.isConnected && this.video === video) {
            video.autoplay = false;
            this.updateButtons();
          }
        }).finally(() => {
          if (this.pendingPlay === playback) this.pendingPlay = null;
        });
      }
    }
    updateButtons() {
      if (!this.video) return;
      if (this.button) {
        this.button.textContent = this.video.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
        this.button.setAttribute('aria-label', this.button.textContent);
      }
      if (this.soundButton) {
        this.soundButton.textContent = this.video.muted ? this.dataset.unmuteLabel : this.dataset.muteLabel;
        this.soundButton.setAttribute('aria-label', this.soundButton.textContent);
      }
    }
    disconnectedCallback() {
      if (!this.video) return;
      this.button?.removeEventListener('click', this.onToggle);
      this.soundButton?.removeEventListener('click', this.onSound);
      this.video.removeEventListener('playing', this.onPlaying);
      this.video.removeEventListener('pause', this.onState);
      this.video.removeEventListener('volumechange', this.onState);
      this.video.removeEventListener('ended', this.onEnded);
      this.video.removeEventListener('error', this.onError);
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.video.removeEventListener('canplay', this.onReady);
      window.removeEventListener('pageshow', this.onPageShow);
      this.video.autoplay = false;
      this.video.pause();
      this.pendingPlay = null;
      this.video = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simluxx-racing-experience"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('simluxx-racing-experience')) {
    customElements.define('simluxx-racing-experience', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.querySelectorAll('[data-platform]').forEach(platform => {
          const select = platform.querySelector('select');
          if (!select) return;
          const update = () => {
            platform.querySelectorAll('[data-brand-panel]').forEach(panel => {
              panel.hidden = panel.id !== select.value;
              if (panel.hidden) this.stopVideos(panel);
            });
          };
          select.addEventListener('change', update, options);
          platform.querySelector('.slx-custom__select-row').hidden = false;
          update();
        });
        this.addEventListener('shopify:block:select', event => {
          const panel = event.target.closest('[data-brand-panel]');
          if (!panel || !this.contains(panel)) return;
          const platform = panel.closest('[data-platform]');
          const select = platform.querySelector('select');
          if (!select) return;
          select.value = panel.id;
          select.dispatchEvent(new Event('change'));
        }, options);
        this.querySelectorAll('[data-youtube-player]').forEach(player => {
          player.querySelector('[data-video-play]').hidden = false;
          player.querySelector('[data-video-fallback]').hidden = true;
        });
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-video-play]');
          if (!button || !this.contains(button)) return;
          const player = button.closest('[data-youtube-player]');
          const frame = player.querySelector('[data-brand-youtube]');
          frame.src = frame.dataset.src;
          frame.hidden = false;
          player.querySelector('[data-video-cover]').hidden = true;
          frame.focus();
        }, options);
        this.classList.add('is-ready');
      }
      stopVideos(scope) {
        scope.querySelectorAll('video').forEach(video => video.pause());
        scope.querySelectorAll('[data-youtube-player]').forEach(player => {
          const frame = player.querySelector('[data-brand-youtube]');
          frame.removeAttribute('src');
          frame.hidden = true;
          player.querySelector('[data-video-cover]').hidden = false;
        });
      }
      disconnectedCallback() { this.events?.abort(); this.stopVideos(this); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simluxx-simulator-video"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('simluxx-rental-video')) {
  customElements.define('simluxx-rental-video', class extends HTMLElement {
    connectedCallback() {
      if (this.video) return;
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.frame = this.querySelector('[data-slx-video-frame]');
      this.button = this.querySelector('[data-slx-toggle]');
      this.soundButton = this.querySelector('[data-slx-sound]');
      this.controlsRow = this.querySelector('[data-slx-controls]');
      this.errorLink = this.querySelector('[data-slx-fallback]');
      this.intent = this.intent || 'auto';
      this.video.controls = false;
      this.video.defaultMuted = true;
      this.video.muted = true;
      this.video.playsInline = true;
      this.video.removeAttribute('controls');
      this.onToggle = () => {
        this.intent = this.video.paused ? 'play' : 'pause';
        this.syncPlayback();
      };
      this.onSound = () => {
        this.video.muted = !this.video.muted;
        this.updateButtons();
        if (!this.video.muted) {
          this.intent = 'play';
          this.syncPlayback();
        }
      };
      this.onState = () => this.updateButtons();
      this.onPlaying = () => {
        if (this.errorLink) this.errorLink.hidden = true;
        this.updateButtons();
      };
      this.onEnded = () => {
        this.intent = 'pause';
        this.video.autoplay = false;
        this.updateButtons();
      };
      this.onError = () => {
        if (this.errorLink) this.errorLink.hidden = false;
        this.updateButtons();
      };
      this.onVisibility = () => this.syncPlayback();
      this.onReady = () => this.syncPlayback();
      this.onPageShow = () => this.syncPlayback();
      this.button?.addEventListener('click', this.onToggle);
      this.soundButton?.addEventListener('click', this.onSound);
      this.video.addEventListener('playing', this.onPlaying);
      this.video.addEventListener('pause', this.onState);
      this.video.addEventListener('volumechange', this.onState);
      this.video.addEventListener('ended', this.onEnded);
      this.video.addEventListener('error', this.onError);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.video.addEventListener('canplay', this.onReady);
      window.addEventListener('pageshow', this.onPageShow);
      if (this.controlsRow) this.controlsRow.hidden = false;
      this.updateButtons();
      this.syncPlayback();
    }
    syncPlayback() {
      if (!this.video || !this.isConnected) return;
      const wantsPlay = this.intent === 'play' || (this.intent === 'auto' && this.dataset.autoplay === 'true');
      const shouldPlay = wantsPlay && !document.hidden;
      this.video.autoplay = shouldPlay;
      if (!shouldPlay) {
        this.video.pause();
        this.updateButtons();
        return;
      }
      if (!this.video.paused || this.pendingPlay) return;
      const video = this.video;
      const playback = video.play();
      if (playback && typeof playback.catch === 'function') {
        this.pendingPlay = playback;
        playback.catch(() => {
          if (this.isConnected && this.video === video) {
            video.autoplay = false;
            this.updateButtons();
          }
        }).finally(() => {
          if (this.pendingPlay === playback) this.pendingPlay = null;
        });
      }
    }
    updateButtons() {
      if (!this.video) return;
      if (this.button) {
        this.button.textContent = this.video.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
        this.button.setAttribute('aria-label', this.button.textContent);
      }
      if (this.soundButton) {
        this.soundButton.textContent = this.video.muted ? this.dataset.unmuteLabel : this.dataset.muteLabel;
        this.soundButton.setAttribute('aria-label', this.soundButton.textContent);
      }
    }
    disconnectedCallback() {
      if (!this.video) return;
      this.button?.removeEventListener('click', this.onToggle);
      this.soundButton?.removeEventListener('click', this.onSound);
      this.video.removeEventListener('playing', this.onPlaying);
      this.video.removeEventListener('pause', this.onState);
      this.video.removeEventListener('volumechange', this.onState);
      this.video.removeEventListener('ended', this.onEnded);
      this.video.removeEventListener('error', this.onError);
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.video.removeEventListener('canplay', this.onReady);
      window.removeEventListener('pageshow', this.onPageShow);
      this.video.autoplay = false;
      this.video.pause();
      this.pendingPlay = null;
      this.video = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
